import { IShop } from './shop.interface';
import { IPaymentMethod } from './payment-method.interface';
import { IUser } from './user';
import { IAccountCode, IPromotion, ITax } from './catalog';
import { DiscountType, IOrder, IOrderCancelReason, OrderChannel } from './order.interface';
import { OrderMode } from '@tickeat/types';

export interface IService {
  _id: string;
  serviceNumber: number;
  user: IUser;
  shop: Pick<
    IShop,
    | '_id'
    | 'internalName'
    | 'publicName'
    | 'slug'
    | 'siret'
    | 'disabled'
    | 'description'
    | 'address'
    | 'phone'
    | 'email'
    | 'website'
  >;

  caTTC: number;
  caHT: number;
  caTVA: number;

  fromDate: string;
  toDate: string;

  // zRegister: IZRegister;
  orders: IOrder[];

  byPaymentMethod: { method: IPaymentMethod; total: number; quantity: number }[];
  byTaxes: {
    caTTC: number;
    caHT: number;
    caTVA: number;
    tax: ITax;
  }[];

  byOrderMode: {
    mode: OrderMode;
    quantity: number;
    caTTC: number;
    orderAverage?: number;
    caHT: number;
    caTVA: number;
  }[];

  byOrderChannel: {
    channel: OrderChannel;
    quantity: number;
    caTTC: number;
    orderAverage?: number;
    caHT: number;
    caTVA: number;
  }[];

  byAccountCodes: {
    accountCode: IAccountCode;
    quantity: number;
    caTTC: number;
    // caHT: number,
    // caTVA: number,
  }[];

  byPromotions: {
    promotion: Pick<IPromotion, '_id' | 'name'>;
    quantity: number;
    caTTC: number;
    // caHT: number,
    // caTVA: number,
  }[];

  byDiscounts: {
    orderId: string;
    type: DiscountType;
    amount: number;
    discountAmount: number;
  }[];

  byCancelledOrdersReasons: {
    quantity: number;
    caTTC: number;
    reason: IOrderCancelReason;
  }[];

  createdAt: string;
  updatedAt: string;
}
